module.exports = __webpack_public_path__ + "img/294.839f4b0d.jpg";